import { 
  collection, addDoc, deleteDoc, doc, 
  query, where, orderBy, getDocs, serverTimestamp 
} from "firebase/firestore";
import { db } from "../lib/firebase";

export interface Notice {
  id?: string;
  type: 'admin' | 'chef';
  title: string;
  message: string;
  authorName: string;
  authorId: string;
  createdAt: any;
}

export const addNotice = async (notice: Omit<Notice, 'id' | 'createdAt'>) => {
  await addDoc(collection(db, "notices"), {
    ...notice,
    createdAt: serverTimestamp(),
    active: true
  });
};

export const getActiveNotices = async (): Promise<Notice[]> => {
  const q = query(
    collection(db, "notices"),
    where("active", "==", true),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  // Chef notices carry expiresAt (e.g. "Today's evening snacks"); hide them once expired instead of
  // showing them on the home page until someone deletes them.
  const now = Date.now();
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() } as Notice))
    .filter(n => {
      const exp: any = (n as any).expiresAt;
      if (!exp) return true;
      const ms = typeof exp.toMillis === "function" ? exp.toMillis() : new Date(exp).getTime();
      return !Number.isFinite(ms) || ms > now;
    });
};

export const deleteNotice = async (noticeId: string) => {
  // We actually just soft-delete or hard delete. Hard delete for now.
  await deleteDoc(doc(db, "notices", noticeId));
};